var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 80 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1432",
    "data-name": "Grupo 1432",
    transform: "translate(-1397 -13580)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_139",
    "data-name": "Elipse 139",
    cx: 35,
    cy: 35.5,
    rx: 35,
    ry: 35.5,
    transform: "translate(1402 13585)",
    fill: "#00b0ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_140",
    "data-name": "Elipse 140",
    transform: "translate(1397 13580)",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 40,
    ry: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 39.5,
    ry: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_6",
    "data-name": "Pol\\xEDgono 6",
    d: "M8.252,3.147a2,2,0,0,1,3.5,0l6.6,11.882A2,2,0,0,1,16.6,18H3.4a2,2,0,0,1-1.748-2.971Z",
    transform: "translate(1449 13611) rotate(90)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.de0581127370bc3815c431cff630433b.svg";
export { ForwardRef as ReactComponent };